export default {"src":"/_next/static/media/help.45bebc0e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};